import React, { useEffect, useRef, useState } from "react";
import Card from "react-bootstrap/Card";
import { Http } from "../../utility/http";
import { apiHeaders } from "../../utility/generic";
import { SkeletonComp } from "../../shared/Skeleton/Skeleton";
import { Link } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addUserModalToggle,
  editUserModalToggle,
} from "../../state/atom/settings";
import {
  addUserToggle,
  editUserToggle,
  updateUserList,
  userId,
  usersListToggle,
} from "../../state/atom/user";
import { ROLESNAME } from "../../shared/role.constant";
import { ROLES_TYPE } from "../../shared/role.interface";
import { IUserStatus, User } from "../../shared/user.interface";
import { UserStatus } from "../../shared/user.constant";
import { AddUserModal } from "./Modals/UserManagment/AddUserManagmentModal";
import { EditUserModal } from "./Modals/UserManagment/EditUserManagmentModal";
import { toaster } from "../../state/atom/toaster";
import { Modal, Button } from "react-bootstrap";

export const UserManagmentTableList: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showAddModal, setShowAddModal] = useRecoilState(
    addUserModalToggle
  );
  const [showEditModal, setShowEditModal] = useRecoilState(
    editUserModalToggle
  );
  //const [users] = useRecoilState(userList);

  //const setBusinessUnitId = useSetRecoilState(businessUnitIdState);
  const [userList, setUserList] = useState([]);
  const [userListCloneData, setUserListCloneData] = useState([]);
  const ITEMS_PER_PAGE: number = 5;
  const SR_NO = (currentPage - 1) * ITEMS_PER_PAGE + 1;
  const TOTAL_PAGES = Math.ceil(userList.length / ITEMS_PER_PAGE);
  // Calculate the range of visible pages based on the current page
  const VISIBLE_PAGE = 5;
  const startPage = Math.max(1, currentPage - Math.floor(VISIBLE_PAGE / 2));
  const endPage = Math.min(TOTAL_PAGES, startPage + VISIBLE_PAGE - 1);

  const [userListToggle, setUserListToggle] = useRecoilState(usersListToggle);
  const setUserEditToggle = useSetRecoilState(editUserToggle);
  const [userID, setUserID] = useRecoilState(userId);
  const setToasterStatus = useSetRecoilState(toaster);
  const setUpdateUsersList = useSetRecoilState(updateUserList);
  const setAddUserToggle = useSetRecoilState(addUserToggle);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedUserID, setSelectedUserID] = useState("");
  
  

  useEffect(() => {
    const getUser = () => {
      setLoading(true);
      Http.request(
        "get",
        `${process.env.REACT_APP_API_URL}users`,
        null,
        apiHeaders()
      )
        .then((result: any) => {
          setUserList(result.data.user);
          setUserListCloneData(result.data.user);
          setLoading(false);
        })
        .catch((error: any) => {
          console.error(error);
          setLoading(false);
        });
    };
    getUser();
  }, [showAddModal, showEditModal]);

  //pagination code...
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const paginateData = userList.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // handle for edit user
  const setUserEditData = (id: string) => {
    setUserEditToggle(true);
    setUserID(id);
  };

  // handle delete  user
  const handleDeleteUser = (id: string) => {
    setUserID(id);
    setSelectedUserID(id);
    setShowDeleteConfirmation(true);
  };

  // delete user confirmed
  const deleteConfirmed = () => {
    // Make the DELETE request for delete the user
    Http.request(
      "delete",
      `${process.env.REACT_APP_API_URL}users/${selectedUserID}`,
      null,
      apiHeaders()
    )
      .then((data) => {
        //setListHighLighter(false);
        // Show a success notification to the user
        setToasterStatus({
          status: true,
          title: "User Deleted",
          text: "User Deleted successfully",
        });

        // hide the user list
        setUserListToggle(false);

        // update the user list
        setUpdateUsersList(true);
      })
      .catch((err) => {});

    // hide the confirmation model
    setShowDeleteConfirmation(false);
  };

  // handle the checkbox for assign the dashboard access.
  const handleCheckboxUpdate = (isDashboardActive: boolean, id: string) => {
    const updatedValue = {
      dashboardAccess: !isDashboardActive,
    };

    // Make the PATCH request the assign the user
    Http.request(
      "PATCH",
      `${process.env.REACT_APP_API_URL}users/${id}`,
      updatedValue,
      apiHeaders()
    )
      .then((data) => {
        // Show a success notification to the user
        setToasterStatus({
          status: true,
          title: "Dashboard",
          text: "Dashboard access updated successfully",
        });

        // update the user list
        setUpdateUsersList(true);
      })
      .catch((err) => {});
  };

  // handle search user
  const filterRequest = (e: any) => {
    let filteredRequest: any = userListCloneData.filter((req: User) => {
      return (
        req.firstName.toLowerCase().indexOf(e.target.value.toLowerCase()) !==
          -1 ||
        req.lastName.toLowerCase().indexOf(e.target.value.toLowerCase()) !==
          -1 ||
        req.email.toLowerCase().indexOf(e.target.value.toLowerCase()) !==
          -1 /* ||
            req.businessUnitName.name
              .toLowerCase()
              .indexOf(e.target.value.toLowerCase()) !== -1 */
      );
    });
    setUserList(filteredRequest);
  };

  // Add user button
  // const handleAddUserFormToggle: any = () => {
  //   setAddUserToggle(true);
  // };

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClearSearch = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      setUserList(userListCloneData);
    }
  };

  const handleShowAddModal = () => {
    setShowAddModal(true);
  };

  const handleShowEditModal = () => {
    setShowEditModal(true);
  };
  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Card>
        <div className="text-right panel-title mb-0">
          <span
            style={{ color: "white", fontSize: "24px", paddingLeft: "20px" }}
          >
            Existing User Management
          </span>

          {/* Search box */}
          <div className="form-group has-search user-search-box">
            <span className="fa fa-search form-control-feedback"></span>

            <input
              type="text"
              className="form-control"
              placeholder="Search"
              ref={inputRef}
              onChange={filterRequest}
            />
            {inputRef?.current?.value !== "" && (
              <i
                className="bi bi-x-circle-fill cancle-icon"
                onClick={handleClearSearch}
              ></i>
            )}
          </div>

          <span
            style={{
              paddingRight: "60px",
              paddingTop: "2px",
              paddingBottom: "2px",
            }}
          >
            <button
              type="button"
              className="btn btn-primary btn"
              onClick={handleShowAddModal}
            >
              Add User
            </button>
          </span>
          {/* Close Icon */}
          {/* <span className="close-btn" id="state-mgt-close">
            &times;
          </span> */}
        </div>
        <div
          className="table-responsive table-responsive-lg table-responsive-md table-responsive-xl p-0"
          style={{ maxHeight: "350px" }}
        >
          {/* List of the district in table form */}
          <table className="table align-items-center justify-content-center mb-0 text-white">
            <thead
              style={{ background: "#6a294b", color: "white" }}
              className="table-head"
            >
              <tr>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  No
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  User Name
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  Email Id
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  Employee Id
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  Business
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  Role
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder">
                  Status
                </th>
                <th className="text-uppercase text-xxs font-weight-bolder text-center ps-2">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody style={{ fontSize: "14px" }}>
              {loading && <SkeletonComp totalCol={8} />}
              {/* {!loading &&
                users?.data?.user.map((item: Business, index: number) => {
                  return (
                    <tr key={index} style={{ color: "black" }}>
                      <td>
                        <div className="d-flex px-2">
                          <div className="my-auto">
                            <h6 className="mb-0 text-sm">{SR_NO + index}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        {" "}
                        <p className="text-sm text-uppercase font-weight-bold mb-0">
                          {item.name}
                        </p>
                      </td>
                      <td>
                        <div className="ms-auto">
                          <Link
                            className="fixed-plugin-button btn btn-sm  btn-primary text-gradient"
                            to=""
                            onClick={() => {
                              setBusinessUnitId(item.id);
                              handleShowEditModal();
                            }}
                          >
                            <i className="material-icons">edit</i>
                          </Link>
                          &nbsp;
                          <Link
                          className="fixed-plugin-button btn btn-sm btn-danger text-gradient"
                          to=""
                          // onClick={handleShowDeleteModal}
                        >
                          <i className="material-icons">close</i>
                        </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })} */}
              {paginateData.map((item: any, index: number) => {
                return (
                  <tr key={index} style={{ color: "black" }}>
                    <td>
                      <div className="d-flex px-2">
                        <div className="my-auto">
                          <h6 className="mb-0 text-sm">{index + 1}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p className="text-sm font-weight-bold mb-0">{`${item.firstName} ${item.lastName}`}</p>
                    </td>
                    <td>
                      <p className="text-sm font-weight-bold mb-0">
                        {item.email}
                      </p>
                    </td>
                    <td>
                      <p className="text-sm font-weight-bold mb-0">
                        {item.employeeId == null ? "-" : item.employeeId}
                      </p>
                    </td>
                    <td>
                      <p className="text-sm font-weight-bold mb-0">
                        <ul>
                          {item?.businessUnitName?.map((unit: any) => {
                            return <li key={unit.id}>{unit.name}</li>;
                          })}
                        </ul>
                      </p>
                    </td>

                    <td>
                      <p className="text-sm font-weight-bold mb-0">
                        {item.role == null
                          ? "-"
                          : Object.keys(ROLESNAME)
                              .filter((unit) => unit === item.role)
                              .map(
                                (unit) => ROLESNAME[unit as keyof ROLES_TYPE]
                              )}
                      </p>
                    </td>
                    <td>
                      <p className="text-sm font-weight-bold mb-0">
                        {
                          UserStatus[
                            item.verificationStatus as keyof IUserStatus
                          ]
                        }
                      </p>
                    </td>
                    <td>
                      <div className="ms-auto text-center">
                        <Link
                          className="fixed-plugin-button btn btn-link text-black text-gradient"
                          to=""
                          onClick={() => {
                            setAddUserToggle(false);
                            setUserEditData(item.id);
                            //setListHighLighter(true);
                            handleShowEditModal();
                          }}
                        >
                          <i className="material-icons text-sm me-2">edit</i>
                        </Link>
                        <Link
                          className="fixed-plugin-button btn btn-link text-black text-gradient"
                          to=""
                          onClick={() => {
                            handleDeleteUser(item.id);
                            //setListHighLighter(true);
                          }}
                        >
                          <i className="material-icons text-sm me-2">close</i>
                        </Link>
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck6"
                          checked={item.dashboardAccess}
                          onChange={() =>
                            handleCheckboxUpdate(item.dashboardAccess, item.id)
                          }
                        />
                        &nbsp;
                        <label
                          className="custom-control-label"
                          htmlFor="customCheck6"
                        >
                          Dashboard
                        </label>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {!loading && (
          <div className="d-flex justify-content-center pt-3">
            <Pagination>
              {currentPage > 1 && (
                <>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                </>
              )}
              {Array.from({ length: endPage - startPage + 1 }).map(
                (_, index: number) => (
                  <Pagination.Item
                    key={startPage + index}
                    active={startPage + index === currentPage}
                    onClick={() => handlePageChange(startPage + index)}
                  >
                    {startPage + index}
                  </Pagination.Item>
                )
              )}
              {currentPage !== TOTAL_PAGES && (
                <>
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === TOTAL_PAGES}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(TOTAL_PAGES)}
                    disabled={currentPage === TOTAL_PAGES}
                  />
                </>
              )}
            </Pagination>
          </div>
        )}
      </Card>
      <Modal
        show={showDeleteConfirmation}
        onHide={() => setShowDeleteConfirmation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete User</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this user?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteConfirmation(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={deleteConfirmed}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {showAddModal && <AddUserModal />}
      {showEditModal && <EditUserModal />}
    </>
  );
};
